<template>
  <div class="courseViewcontainer">
    <div class="coursenav">
      <a href="#" v-if="!noClose" @click="close" class="bigScreenNav">
        <div class="circularBtn">
          <div class="rounded-circle"></div>
          <div class="rounded-circle d-flex align-items-center justify-content-center">
            <h1><img src="@img/close.svg" alt=""></h1>
          </div>
        </div>
      </a>
    </div>
    <div class="page-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: {
    back: {type: Object, default: () => ({name: 'home'})},
    modal: {type: Boolean, default: false},
    noClose: {type: Boolean, default: false}
  },
  methods: {
    close() {
      if (this.modal) return this.$emit('close')
      if (this.back) this.$router.push(this.back)
    }
  }
}
</script>

<style lang="scss" scoped>
.courseViewcontainer {
  background: #F5F5F5 url('~@img/font_home.png') -50px -50px repeat padding-box !important;
  width: 100vw;
  min-height: 100vh;
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;

  > .page-content {
    padding-top: 100px;
    padding-bottom: 100px;
    @include down(768) {
      padding-top: 20px;
    }
  }

  .coursenav {
    width: 100vw;
    height: 100px;
    position: fixed;

    @include down(768) {
      position: relative;
    }

    .circularBtn {
      // background:white;
      height: 60px;
      top: 10px;
      right: 20px;
      // right: 0;
      width: 60px;
      position: absolute;

      &:hover {
        > div {
          &:first-child {
            display: none;
          }

          &:last-child {
            left: 0px;
            top: 10px;
          }
        }
      }

      > div {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 0;
        transition: all 0.2s ease-in-out;

        &:first-child {
          background: $green;;
          left: 0px;
          top: 10px;
          position: relative;
        }

        &:last-child {
          background-color: white;
          left: 5px;
          top: 5px;
          /*transform: rotate(45deg);*/
        }

      }
    }
  }
}
</style>
